export var isAndroid = typeof window !== 'undefined' && /Android/i.test(navigator.userAgent);
export var isIOS = typeof window !== 'undefined' && /iPhone|iPad|iPod/i.test(navigator.userAgent);
export var DWELL_CONFIG_RETRY = 5;
export var shouldEnableDwellLogging = function () {
    if (typeof window === 'undefined') {
        return false;
    }
    return true;
};
/**
 * Generate a unique page ID from route location
 * Format: pathname + query params (excluding sensitive data)
 * @param location - Route location object with pathname, query, and/or search
 * @returns Page ID string
 */
export function generatePageId(location) {
    if (!location) {
        return '';
    }
    var pathname = location.pathname || '';
    var query = location.query || {};
    var search = location.search || '';
    // Remove locale prefix from pathname
    var pagePath = pathname.replace(/^\/(en|hi|ta|te|kn|ml|mr|gu|pa|bn|as|or)\//, '/');
    var relevantParams = [];
    var relevantKeys = ['order_id', 'unit_id', 'item_id', 'issueId', 'catalogId', 'chatId'];
    // Try to get params from query object first
    if (typeof query === 'object' && query !== null && !Array.isArray(query)) {
        relevantKeys.forEach(function (key) {
            if (query[key]) {
                relevantParams.push(key + "=" + query[key]);
            }
        });
    }
    else if (search && typeof search === 'string') {
        // Fallback to parsing search string
        try {
            var params_1 = new URLSearchParams(search);
            relevantKeys.forEach(function (key) {
                var value = params_1.get(key);
                if (value) {
                    relevantParams.push(key + "=" + value);
                }
            });
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
    }
    if (relevantParams.length > 0) {
        pagePath += '?' + relevantParams.join('&');
    }
    return pagePath;
}
